import utils from '@src/common/utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '任务名称',
        prop: 'taskName',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 24,
        align: 'center'
      },
      {
        label: '巡检人',
        prop: 'inspectPersonList',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        formatter: function (row, value) {
          const nameList = []
          if (value && value.length) {
            value.map(item =>{
              nameList.push(item.nickName)
            })
          }
          return nameList.toString();
        }
      },
      {
        label: '状态',
        prop: 'status',
        type: 'select',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        // formslot: true,
        span: 12,
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return '待巡检'
          } else if (Number(value) === 2) {
            return '执行中'
          } else if(Number(value) === 3){
            return '已完成'
          } else if(Number(value) === 4){
            return '超时'
          } 
          return '';
        },
        dicData: [
          {
            label: '待巡检',
            value: 1
          },
          {
            label: '执行中',
            value: 2
          },
          {
            label: '已完成',
            value: 3
          },
          {
            label: '超时',
            value: 4
          }
        ],
        align: 'center'
      }
    ]
  }
}
export default tableOption